export default __webpack_public_path__ + "images/HU.69fa829.png";